module.exports = __webpack_public_path__ + "static/fonts/Nunito-BlackItalic.34c244e.woff2";